<template>
  <Modal
    class-name="hn-modal"
    :width="width"
    v-model="visibility"
    footer-hide
    :closable="false"
    :mask-closable="false"
  >
    <slot name="header"></slot>
    <Icon class="hn-modal-close" size="38" type="ios-close-circle-outline" @click="visibility = false" />
    <div class="hn-modal-content" :style="styles"><slot></slot></div>
    <slot name="footer"></slot>
  </Modal>
</template>
<script>
export default {
  name: "commonModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 520,
    },
    styles:{ // 内容区样式
        type: Object,
        default: () => {},
    }
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
};
</script>

<style lang="less" >
.hn-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal-body{
      // padding: 0 0 30px 0;
      padding: 0;
  }
  .ivu-modal {
    top: 0;
  }
  .hn-modal-close{
      position: absolute;
      top: -2px;
      right: -50px;
      color: #333333;
      cursor: pointer;
  }
}
</style>